import { render, staticRenderFns } from "./CreateRegulator.vue?vue&type=template&id=c107edd2&"
import script from "./CreateRegulator.vue?vue&type=script&lang=ts&"
export * from "./CreateRegulator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports